import "./widget.scss";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getCountFromServer,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import { MenuBookOutlined, SchoolOutlined } from "@mui/icons-material";

const Widget = ({ type }) => {
  const [amount, setAmount] = useState(0);
  const [diff, setDiff] = useState(0);
  const [isLoading, setLoading] = useState(true);
  let data;

  switch (type) {
    case "user":
      data = {
        title: "USERS",
        isMoney: false,
        link: "See all users",
        query: "Users",
        fieldvalue: "publish_on",

        icon: (
          <PersonOutlinedIcon
            className="icon"
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
            }}
          />
        ),
      };
      break;
    case "order":
      data = {
        title: "ORDERS",
        query: "Library",
        fieldvalue: "name",
        isMoney: false,
        link: "View all orders",
        icon: (
          <ShoppingCartOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(218, 165, 32, 0.2)",
              color: "goldenrod",
            }}
          />
        ),
      };
      break;
    case "publishers":
      data = {
        title: "AUTHORS/PUBLISHERS",
        isMoney: false,
        query: "publishers",
        fieldvalue: "accountCreatedOn",
        link: "See all Publisher",
        icon: (
          <SchoolOutlined
            className="icon"
            style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
          />
        ),
      };
      break;
    case "product":
      data = {
        title: "BOOKS/NOTES",
        query: "eLibrary",
        fieldvalue: "publish_on",
        link: "See details",
        icon: (
          <MenuBookOutlined
            className="icon"
            style={{
              backgroundColor: "rgba(128, 0, 128, 0.2)",
              color: "purple",
            }}
          />
        ),
      };
      break;
    default:
      break;
  }

  useEffect(() => {
    const fetchData = async () => {
      const today = new Date();
      const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1));
      const prevMonth = new Date(new Date().setMonth(today.getMonth() - 2));

      const lastMonthQuery = query(
        collection(db, data.query),
        where(data.fieldvalue, "<=", today),
        where(data.fieldvalue, ">", lastMonth)
      );
      const prevMonthQuery = query(
        collection(db, data.query),
        where(data.fieldvalue, "<=", lastMonth),
        where(data.fieldvalue, ">", prevMonth)
      );

      const lastMonthData = await getCountFromServer(lastMonthQuery);
      const prevMonthData = await getCountFromServer(prevMonthQuery);
      const countdata = await getCountFromServer(
        query(
          data.query === "Library"
            ? collectionGroup(db, data.query)
            : collection(db, data.query)
        )
      );

      setAmount(countdata.data().count);
      let lm = lastMonthData.data().count;
      let pm = prevMonthData.data().count;
      if (lm === 0 || pm === 0) {
        setDiff(0);
      } else {
        setDiff(((lm - pm) / pm) * 100);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <>
      {isLoading && (
        <div className="widget">
         Loading...
        </div>
      )}
      {!isLoading && (
        <div className="widget">
          <div className="left">
            <span className="title">{data.title}</span>

            <span className="counter">{amount}</span>
          </div>
          <div className="right">
            <div className={`percentage ${diff < 0 ? "negative" : "positive"}`}>
              {diff < 0 ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
              {diff} %
            </div>
            {data.icon}
          </div>
        </div>
      )}
    </>
  );
};

export default Widget;
